import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pl-xl-2 pl-xl-2 pl-mb-1" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "card-title mb-4" }, "Calificación de llamada", -1)
const _hoisted_4 = { class: "container ct-example-row mb-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Tipificación", -1)
const _hoisted_8 = { class: "col-12 mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, "Subtipificación", -1)
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "Comentario", -1)
const _hoisted_12 = { class: "float-sm-right mt--3 mr-3" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Enviar evaluación ")

import { ref, computed } from "vue";
import type { Ref } from "vue";

import { CallDataModule } from "@/store/modules/CallData";
import { ISubtypification, ICoreEvaluation } from "@/callcenter/omni";
import { Promotion } from "@element-plus/icons";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const Typifications = computed(() => {
	return CallDataModule.Typifications;
});
const SubTypification: Ref<ISubtypification[] | undefined> = ref(undefined);
const model = ref({
	IdTypification: "",
	IdSubtypification: "",
	Comment: "",
});
const changeSubTypification = () => {
	model.value.IdSubtypification = "";
	SubTypification.value = Typifications.value?.find(
		x => x._id == model.value.IdTypification
	)?.subtipificacion;
};
const sendEvaluation = () => {
	const evaluation: ICoreEvaluation = {
		tipificacion: model.value.IdTypification,
		subtipificacion: model.value.IdSubtypification,
		comment: model.value.Comment,
	};
	CallDataModule.sendEvaluation({
		Evaluation: evaluation,
		typificationName: Typifications.value?.find(
			x => x._id == model.value.IdTypification
		)?.tipificacion,
		subtypificationName: SubTypification.value?.find(
			x => x._id == model.value.IdSubtypification
		)?.subtipificacion,
		comentario: model.value.Comment,
	});
	// };
	// console.log("Send Evaluation");
	//CallDataModule.sendEvaluation(evaluation);
	model.value.Comment = "";
	model.value.IdSubtypification = "";
	model.value.IdTypification = "";
};
const scorign = computed(() => {
	return CallDataModule.scoring;
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_el_select, {
                  modelValue: model.value.IdTypification,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.IdTypification) = $event)),
                  placeholder: "Tipificación",
                  class: "d-block",
                  size: "large",
                  onChange: changeSubTypification,
                  disabled: !_unref(scorign),
                  filterable: "",
                  name: "typification"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Typifications), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item._id,
                        label: item.tipificacion,
                        value: item._id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_el_select, {
                  modelValue: model.value.IdSubtypification,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.IdSubtypification) = $event)),
                  placeholder: "Subtipificación",
                  class: "d-block",
                  size: "large",
                  disabled: !_unref(scorign),
                  filterable: "",
                  name: "subtipificacion"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(SubTypification.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item.subtipificacion,
                        value: item._id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_el_input, {
                  modelValue: model.value.Comment,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.Comment) = $event)),
                  placeholder: "Comentario",
                  type: "textarea",
                  disabled: !_unref(scorign)
                }, null, 8, ["modelValue", "disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_base_button, {
              size: "sm",
              type: "success",
              onClickCapture: sendEvaluation,
              disabled: !_unref(scorign)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_el_icon, {
                    size: 20,
                    color: "#FFFFF",
                    class: "no-inherit"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Promotion))
                    ]),
                    _: 1
                  }),
                  _hoisted_14
                ])
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})